import styled from 'styled-components';

const StylePaginationLess = styled.div`
  .ant-pagination {
    display: none;
  }
`;

export default StylePaginationLess;
